/* Formularz kontaktowy (23.09.2026) — obsługa dialogu renderowanego server-side
   przez snippets/contact-dialog.liquid ({% form 'contact' %}). Ten plik tylko
   ustawia temat/treść per przycisk i otwiera/zamyka dialog — sam submit to
   zwykły POST przeglądarki do /contact, żadnego JS przechwytywania (inaczej
   niż w prototypie, gdzie nie było prawdziwego endpointu). */
(function () {
  const TOPICS = {
    demo: {
      title: "Umów demo",
      lead: "Zostaw kontakt — odezwiemy się, żeby ustalić termin prezentacji StethoMe®.",
      subject: "Umów demo",
      msg: "Czego ma dotyczyć prezentacja? (opcjonalnie)",
    },
    wycena: {
      title: "Zapytaj o wycenę",
      lead: "Napisz, czego potrzebujesz — przygotujemy ofertę dopasowaną do Twojej placówki.",
      subject: "Zapytaj o wycenę",
      msg: "Ilu pacjentów lub stanowisk dotyczy zapytanie?",
    },
    wspolpraca: {
      title: "Porozmawiajmy o współpracy",
      lead: "Napisz, czego dotyczy projekt — odezwiemy się.",
      subject: "Współpraca naukowa",
      msg: "Kilka słów o projekcie",
    },
    kontakt: {
      title: "Napisz do nas",
      lead: "Odpowiemy na adres e-mail, który podasz.",
      subject: "Kontakt",
      msg: "Wiadomość",
    },
  };

  const dlg = document.getElementById("contactDialog");
  if (!dlg) return;

  let opener = null;
  const close = () => dlg.close();

  const closeBtn = dlg.querySelector(".cform__close");
  if (closeBtn) closeBtn.addEventListener("click", close);
  const okBtn = dlg.querySelector(".cform__ok");
  if (okBtn) okBtn.addEventListener("click", close);
  dlg.addEventListener("click", (e) => {
    if (e.target === dlg) close();
  });
  dlg.addEventListener("close", () => {
    if (opener) opener.focus();
  });

  const applyTopic = (key) => {
    const t = TOPICS[key] || TOPICS.kontakt;
    const title = dlg.querySelector("#cform-title");
    if (title) title.textContent = t.title;
    const lead = dlg.querySelector('[data-view="form"] .cform__lead');
    if (lead) lead.textContent = t.lead;
    const msgLabel = dlg.querySelector(".cform__msg-label");
    if (msgLabel) msgLabel.textContent = t.msg;
    const temat = dlg.querySelector('[name="contact[Temat]"]');
    if (temat) temat.value = t.subject;
    const strona = dlg.querySelector('[name="contact[Strona]"]');
    if (strona) strona.value = location.pathname;
  };

  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-contact]");
    if (!a) return;
    e.preventDefault();
    opener = a;
    applyTopic(a.getAttribute("data-contact"));
    dlg.showModal();
    const nameField = dlg.querySelector('[name="contact[name]"]');
    if (nameField) nameField.focus();
  });

  // Shopify przeladowało stronę po udanej wysyłce (form.posted_successfully?) —
  // otwórz dialog od razu na widoku "Dziękujemy!", bez czekania na klik.
  if (dlg.dataset.posted === "true") {
    dlg.showModal();
  }
})();
